"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LINK_DESTINATION_NONE = exports.LINK_DESTINATION_MEDIA = exports.LINK_DESTINATION_ATTACHMENT = void 0;
const LINK_DESTINATION_NONE = 'none';
exports.LINK_DESTINATION_NONE = LINK_DESTINATION_NONE;
const LINK_DESTINATION_MEDIA = 'file';
exports.LINK_DESTINATION_MEDIA = LINK_DESTINATION_MEDIA;
const LINK_DESTINATION_ATTACHMENT = 'post';
exports.LINK_DESTINATION_ATTACHMENT = LINK_DESTINATION_ATTACHMENT;
//# sourceMappingURL=constants.js.map